import TotalsGraph from "widgets/mtt-sustainability-tool/js/TotalsGraph";
import React from "react";
import DataBlock from "widgets/mtt-sustainability-tool/js/DataBlock";
import ToolRow from "widgets/mtt-sustainability-tool/js/ToolRow";
import ToolTextRow from "widgets/mtt-sustainability-tool/js/ToolTextRow";
import YearPicker from "widgets/mtt-sustainability-tool/js/YearPicker";

export default class ToolContent extends React.Component {

    get data() {
        return require('../data.json');
    }

    get tableTexts() {
        return require('../table.json');
    }

    getCategoryHeading(category) {
        return `${this.tableTexts[category].heading} ${this.tableTexts[category].text}`;
    }

    get dataBlocks() {
        let blockData = {};

        this.data.forEach((row, key) => {
            if (!blockData[row.category]) {
                blockData[row.category] = [];
            }

            blockData[row.category].push(row);
        });

        let blocks = [];

        Object.keys(this.tableTexts).forEach(category => {
            blocks.push(
                <div key={category} className={'mtt-sustainability-tool__section mtt-sustainability-tool__wrap'}>
                    <div className={'mtt-sustainability-tool__section-tagline tagline'}>Dimension of sustainability</div>
                    <div className={'mtt-sustainability-tool__section-title mtt-sustainability-tool__wrap-title'}>
                        {this.getCategoryHeading(category)}
                    </div>
                    <DataBlock section={category}>

                        {blockData[category].map((row) => {
                            return <ToolRow {...row} key={row.uuid}/>
                        })}

                    </DataBlock>

                    <ToolTextRow placeholder={'Challenges/Room for improvement:'}/>
                    <ToolTextRow placeholder={'The DTDA contribution to organisational sustainability, please specify:'}/>

                </div>
            )
        });

        return blocks;
    }

    get date() {
        return new Date().toDateString();
    }

    render() {
        return (
            <div className={'mtt-sustainability-tool__tool-wrap'}>
                <div className={'mtt-sustainability-tool__header mtt-sustainability-tool__wrap'}>
                    <div className={'mtt-sustainability-tool__header-wrap noprint'}>
                        <div className={'mtt-sustainability-tool__header-title-container'}>
                            <div className={'mtt-sustainability-tool__header-tagline tagline'}>Sustainability Assessment</div>
                            <div className={'mtt-sustainability-tool__header-title mtt-sustainability-tool__wrap-title'}>Please fill in your information</div>
                        </div>
                        <div className={'mtt-sustainability-tool__print'}>
                            <button className={'button red auto small print'}>Print</button>
                        </div>
                    </div>
                    <div className={'mtt-sustainability-tool__header-inputs'}>
                        <YearPicker/>
                        <div className={'mtt-sustainability-tool__header-input'}>
                            <label htmlFor="organisation" className={'mtt-sustainability-tool__header-label tagline'}>Organisation</label>
                            <input name="organisation" type="text" />
                        </div>
                        <div className={'mtt-sustainability-tool__header-input'}>
                            <label htmlFor="assessed-by" className={'mtt-sustainability-tool__header-label tagline'}>Assessed by</label>
                            <input name="assessed-by" type="text" />
                        </div>
                        <div className={'mtt-sustainability-tool__header-input'}>
                            <label htmlFor="date" className={'mtt-sustainability-tool__header-label tagline'}>Date</label>
                            <input name="date" type="text" value={this.date} readOnly className={'disabled'} />
                        </div>
                    </div>
                </div>
                {this.dataBlocks}
                <TotalsGraph/>
            </div>
        );
    }
}
